import { Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import { CopyText, HelpTooltip } from 'components';

type Props = {
  title: string;
  value?: ReactNode;
  canCopy?: boolean; // render value as copyable CopyText
  secret?: boolean; // mask value behind a reveal toggle (still copyable)
  description?: string;
};

export const DescriptionRow: FC<Props> = ({
  title,
  value,
  canCopy,
  secret,
  description,
}) => (
  <Stack direction="column" spacing={0.5}>
    <Typography variant="subtitle2">
      {title}
      {description && <HelpTooltip title={description} />}
    </Typography>
    {typeof value === 'string' && (secret || canCopy) ? (
      <CopyText text={value} secret={secret} />
    ) : (
      value || '-'
    )}
  </Stack>
);
